document.addEventListener("DOMContentLoaded", (event) => {
	const siteHeader = document.querySelector(".tesl-header");
	if (siteHeader) {
		const nav = siteHeader.querySelector(" & > nav");
		const toggleBtn = siteHeader.querySelector(".mobile-menu-toggler");
		const menuContainer = siteHeader.querySelector("#main-menu-nav");
		const mainMenu = siteHeader.querySelector("#menu-main-nav");

		// Toggle mobile btn
		toggleBtn.addEventListener("click", toggleMobileNav.bind({ toggleBtn, menuContainer }));
		// Expanded Submenu Items on click
		mainMenu.addEventListener("click", expandSubMenuItem.bind({ mainMenu }));
	}

	/**
	 * Reduce nav when scrolled
	 */
	if (siteHeader) {
		window.addEventListener("scroll", function () {
			if (window.scrollY >= siteHeader.offsetHeight) {
				siteHeader.classList.add("add-scrolled");
			} else {
				siteHeader.classList.remove("add-scrolled");
			}
		});
	}
});

/**
 *
 * Mobile Menu toggle
 */
function toggleMobileNav(e) {
	e.preventDefault();
	const { toggleBtn: btn, menuContainer } = this;
	btn.classList.toggle("expanded");

	if (btn.classList.contains("expanded")) {
		btn.setAttribute("aria-expanded", true);
		menuContainer.classList.add("expanded");
	} else {
		btn.setAttribute("aria-expanded", false);
		menuContainer.classList.remove("expanded");
	}
}

/**
 *
 * @param {*} e
 * Expand submenu items
 */
function expandSubMenuItem(e) {
	const { mainMenu } = this;
	if (e.target.classList.contains("dropdown-icon")) {
		const parentLi = e.target.closest("li");
		const subMenu = e.target.nextElementSibling;
		const links = subMenu.querySelectorAll(" & > li > a");
		const subMenuDropdownBtn = subMenu.querySelectorAll(" & > li > .dropdown-icon");
		// console.log(subMenu);
		e.target.classList.toggle("expanded");
		if (e.target.classList.contains("expanded")) {
			e.target.setAttribute("aria-expanded", true);
			subMenu.classList.add("expanded");
			// subMenu.setAttribute("tabindex", 0);

			links.forEach((link) => link.setAttribute("tabindex", 0));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		} else {
			e.target.setAttribute("aria-expanded", false);
			subMenu.classList.remove("expanded");
			// subMenu.setAttribute("tabindex", -1);
			links.forEach((link) => link.setAttribute("tabindex", -1));
			subMenuDropdownBtn.forEach((icon) => icon.setAttribute("tabindex", 0));
		}
	}
}
